"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _createInstance = _interopRequireDefault(require("../node/createInstance"));
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/**
 *  maps footnote elements to a view node
 *
 * @param {*} footnotes
 * @returns a view node
 */
function mapFootnotesToView(footnotes, width) {
  var line = (0, _createInstance.default)({
    type: 'LINE',
    props: {
      x1: 0,
      x2: width,
      y1: 0,
      y2: 0,
      strokeWidth: 1,
      stroke: '#000000'
    }
  });
  var processed = [(0, _createInstance.default)({
    type: 'SVG',
    props: {
      style: {
        height: 5
      },
      children: [line]
    }
  })];
  var j = 0;

  // eslint-disable-next-line no-restricted-syntax
  for (var _iterator = _createForOfIteratorHelperLoose(footnotes), _step; !(_step = _iterator()).done;) {
    var note = _step.value;
    var txt = (0, _createInstance.default)(note.el.props.footnote(j + 1));
    processed.push(txt);
    j += 1;
  }
  var it = (0, _createInstance.default)({
    type: 'VIEW',
    props: {
      style: {
        paddingTop: 10
      },
      children: []
    }
  });
  it.children = processed;
  return it;
}
var _default = exports.default = mapFootnotesToView;